module.exports = __webpack_public_path__ + "static/img/buddy_pictgrid28_920x869.c063b1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/buddy_pictgrid28_920x869.jpg
// module id = S9+Y
// module chunks = 0